<!--
Poster
海报
-->


<template>
  <transition name="el-fade-in-linear">
    <div>
      <el-collapse-item title="海报" name="海报">
        <el-row>
          <el-col :span="24" class="my-middle">
            <el-checkbox
              v-bind:key="select.id"
              v-for="select in poster"
              v-model="select.status"
              v-bind:label="select.name"
              style="width:150px;margin:10px"
              border
            ></el-checkbox>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-collapse v-model="forcollapse" wtfname="posterFormActive">
              <PvcPoster v-if="poster[0].status"/>
              <PaperPoster v-if="poster[1].status"/>
            </el-collapse>
          </el-col>
        </el-row>
      </el-collapse-item>
    </div>
  </transition>
</template>
<script>
import PvcPoster from "./Poster/PvcPoster.vue";
import PaperPoster from "./Poster/PaperPoster.vue";

export default {
  name: "Poster",
  methods: {},
  components: {
    PvcPoster,
    PaperPoster
  },
  data() {
    return {
      forcollapse: ['PVC海报','纸质海报'],
      poster: [
        { id: "PvcPoster", name: "PVC海报", status: false },
        { id: "PaperPoster", name: "纸质海报", status: false }
      ],
      posterFormActive: []
    };
  }
};
</script>
<style scoped>
</style>